import {Link} from '@shopify/hydrogen';
import {changeGTSymbol, reloadUrl} from '../lib/functions';
import { useEffect } from 'react';


export default function Breadcrumbs({data}) {
  const cutLabel = (text)=>{
    
    let hasPipe = (text && text.indexOf('|') > -1) ? text.indexOf('|') : false;

    if(hasPipe){
      return text.substring(0, hasPipe);
    }
    
    return text;
  }

  return (
    <>
      {data?.parent === 'dinamyc' ? (
        <div className="breadcrumbs flex border-b-gray-80 py-3 px-10 border xs:px-5 xs:py-3 xs:justify-between bg-white">
            <Link to="/" className="text-purple-120 mr-2">
              Home
            </Link>
            <span className="mx-1"> > </span>
            {data?.options.map((item, index)=>(
              <div key={index}>
                <Link
                to={`/${item.link}`}
                className="text-purple-120"
              >
                {item.label}
              </Link>

              <span className="mx-1"> > </span>
              </div>
            ))}
        </div>
      ) :  data?.parent ? (
        <div className="breadcrumbs px-10 py-5 xs:pt-10 bg-white pb-3 xs:px-5">
          <Link to="/" onClick={() => window.location.reload()} className="text-purple-120 mr-2">
            Home
          </Link>
          <span className="mx-1"> > </span>
          {data.parent?.slug?.current ? (
            <span>
              <Link
                to={`/categoria-producto/${data.parent?.slug?.current}`}
                className="text-purple-120"
                onClick={reloadUrl}
              >
                {changeGTSymbol(data.parent.title)}
              </Link>

              <span className="mx-1"> > </span>
            </span>
          ) : (
            <span></span>
          )}
          <Link
            to={
              data.parent?.name
                ? data.parent?.seo?._type == 'home'
                  ? `/`
                  : data.parent._type == 'category'
                  ? '/categoria-producto/' +
                    data.parent.slug.current +
                    '/' +
                    data.slug.current
                  : '/'
                : '/'
            }
            className="font-semibold"
            onClick={reloadUrl}
          >
            {changeGTSymbol(data.name ? data?.name : data?.title)}
          </Link>
        </div>
      ) : (
        <div className="breadcrumbs px-8 xs:px-4 py-3 xs:pt-7 bg-white">
          <Link 
            to="/" 
            className="text-purple-120 mr-2"
            onClick={() => window.location.reload()}
          >
            Home
          </Link>{' '}
          <span className="mx-1"> > </span>
          <span className="ml-2"> {changeGTSymbol(cutLabel(data.name  ?  data.name : data.title))} </span>
        </div>
      )}
    </>
  );
}
